import React from "react";
import styles from "./form-section.module.css";

const FormSection = ({ title, renderRight, children, style }) => {
  return (
    <div className={styles.formSection} style={style}>
      <div className={styles.header}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {renderRight && <div className={styles.renderRight}>{renderRight()}</div>}
      </div>
      <div className={styles.inputs}>
        {children}
      </div>
    </div>
  );
};

export default FormSection;